import React, { useState } from 'react';
import { Row, Col, Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import EditDetailsModal from './edit-detai-modal';
import useStyles from '../../style.js';

const InvoiceDetails = ({ landlord, getLandlord, updateLandlord }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const descriptionsArr = [
    {
      label: t('cms.landlord.detail.purchase_order_required.label'),
      value: landlord.purchaseOrderRequired ? t('cms.form.value.yes') : t('cms.form.value.no'),
    },
    {
      label: t('cms.landlord.invoice_info.reconciliation_setting.frequency_label'),
      value: landlord.invoicingFrequency ? landlord.invoicingFrequency.toUpperCase() : undefined,
    },
  ];
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            title={t('cms.landlord.invoice_info.title.invoice_Details')}
            extra={
              <span
                className={classes.formOutLineIcon}
                onClick={() => {
                  setVisible(true);
                }}
              >
                {t('cms.sepcial_offer.edit.btn')}
              </span>
            }
            className={classes.cardWrapper}
            style={{ border: 'none' }}
          >
            <Descriptions column={1} className={classes.descriptionWrapper}>
              {descriptionsArr.map(description => (
                <Descriptions.Item
                  label={description.label}
                  key={`reconciliation_setting${description.label}`}
                >
                  {description.value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Card>
        </Col>
      </Row>
      <EditDetailsModal
        landlord={landlord}
        getLandlord={getLandlord}
        updateLandlord={updateLandlord}
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </>
  );
};
InvoiceDetails.propTypes = {
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
};

export default InvoiceDetails;
